
    import {TipsPart} from '@/profile-creation-wizard/components/for-creation/TipsPart';
    import '@malt/joy-entrypoint/src/js/components/Input/InputPhone.js';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {Options, Ref, Vue, Prop} from 'vue-property-decorator';
    import {eventBusProfileCreationWizard} from '@/profile-creation-wizard/common/events';
    import StepItemTitle from '@/profile-creation-wizard/common/ui/StepItemTitle.vue';
    import type {InputPhoneValidation} from '@/profile-creation-wizard/common/types';

    @Options({
        components: {
            StepItemTitle,
        },
        emits: ['update:modelValue', 'update:validation'],
    })
    export default class PhoneSelection extends Vue {
        @Ref('refLabelPhoneSelection')
        refLabelPhoneSelection!: HTMLElement;
        @Ref('refInputPhoneSelection')
        refInputPhoneSelection!: HTMLInputElement;
        @Prop({type: String})
        modelValue!: string;
        @Prop()
        validation?: InputPhoneValidation;
        @Prop({type: Boolean})
        displayError?: boolean;

        bottomSheetSelector = '#details-phone-bottom-sheet';
        dataHeapTooltipID = 'profile-creation-tooltip-phone';

        mounted(): void {
            this.bottomSheetDisplayer = new BottomSheetDisplayer(
                this.bottomSheetSelector,
                this.dataHeapTooltipID,
                this.$el,
                'div.profile-creation-wizard',
            );
            this.bottomSheetDisplayer.mounted();
        }

        beforeUnmount(): void {
            this.$refs.refInputPhoneSelection.removeAttribute('value');
        }

        onChange($event: Event): void {
            const target = $event.target as HTMLInputElement;
            this.$emit('update:modelValue', target.value);
        }

        openBottomSheet(): void {
            this.bottomSheetDisplayer.openBottomSheet();
        }

        onFocus(): void {
            eventBusProfileCreationWizard.emit('creation:focus-changed', TipsPart.phone);
        }

        onInputPhoneValidation(customEvent: CustomEvent): void {
            const {validated, isInitialising} = customEvent.detail;
            this.$emit('update:validation', {validated, isInitialising});
        }

        get defaultCountry(): string {
            return this.$pageContext.currentCountryCode || 'FR';
        }

        get phoneSelection(): string {
            return this.$refs.refInputPhoneSelection.value;
        }
    }
